import React, { useEffect, useState } from "react";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiRequestHandler } from "../../apiConfig/service";
import { toast } from "react-toastify";
import { url } from "../../apiConfig/ApiConfig";
import DeleteModal from "../../components/DeleteBlogModal";
import Loader from "../../components/Loader";
import { formatDate } from "../../utils/formatedDate";
import DataTable from "react-data-table-component";

const SubAdminManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [subadmins, setSubadmins] = useState([]);
  const [filteredSubadmins, setFilteredSubadmins] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [subadminToDelete, setSubadminToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const fetchSubAdmins = async () => {
    try {
      setIsLoading(true);
      const res = await apiRequestHandler({
        endPoint: `${url}/subadmin/all`,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res?.success) {
        const sortedData = res.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setSubadmins(sortedData);
      } else {
        toast.error(res.message || "Failed to fetch subadmins");
      }
    } catch (err) {
      toast.error("Error while fetching subadmins");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSubAdmins();
  }, []);

  useEffect(() => {
    const filtered =
      subadmins?.filter(
        (sa) =>
          sa.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          sa.email.toLowerCase().includes(searchTerm.toLowerCase())
      ) || [];
    setFilteredSubadmins(filtered);
  }, [searchTerm, subadmins]);

  const handleDeleteSubadmin = async (id) => {
    try {
      setIsLoading(true);
      const res = await apiRequestHandler({
        method: "DELETE",
        endPoint: `${url}/subadmin/delete/${id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res?.success) {
        toast.success(res.message);
        fetchSubAdmins();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      name: 'Sr No.',
      selector: (row, index) => (currentPage - 1) * 10 + index + 1,
      width: '80px',
    }
    ,
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <FaEye
            title="View"
            style={{ color: '#064a8c', marginRight: "10px", cursor: "pointer" }}
            onClick={() =>
              navigate("/admin/add-subadmin", {
                state: { subadmin: row, mode: "view" },
              })
            }
          />
          <FaEdit
            title="Edit"
            style={{ color: "#ff9800", marginRight: "10px", cursor: "pointer" }}
            onClick={() =>
              navigate("/admin/add-subadmin", {
                state: { subadmin: row, mode: "edit" },
              })
            }
          />
          <FaTrash
            title="Delete"
            style={{ color: "#f44336", cursor: "pointer" }}
            onClick={() => {
              setSubadminToDelete(row);
              setShowDeleteModal(true);
            }}
          />
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div style={{ minHeight: "100vh", padding: "20px", background: "#f5f7fa" }}>
      <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "10px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <h4 style={{ margin: 0 }}>SubAdmin Management</h4>
          <button
            onClick={() => navigate("/admin/add-subadmin")}
            style={{
              background: "linear-gradient(to bottom right, #163252, #0081ff)",
              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            + Add SubAdmin
          </button>
        </div>

        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          theme="dark"
          onConfirm={() => {
            handleDeleteSubadmin(subadminToDelete?._id);
            setShowDeleteModal(false);
          }}
        />
      </div>

      <div className="modifyTable" style={{ borderRadius: "10px", marginTop: "20px" }}>
        <DataTable
          title=""
          columns={columns}
          data={filteredSubadmins}
          pagination
          paginationDefaultPage={currentPage}
            onChangePage={setCurrentPage}


          highlightOnHover
          responsive  
          striped
          progressPending={isLoading}
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search by name or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
                width: "250px",
              }}
            />
          }
        />
      </div>
    </div>
  );
};

export default SubAdminManagement;
